import { Component, AfterViewInit, ChangeDetectorRef, Input, OnChanges, Output, EventEmitter, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { MoveService } from '../../../service/move/move.service';
import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';
import { LocaBlockService } from '../../../service/loca-block/loca-block.service';
import { OwnerFunctionService } from '../../../service/owner-function/owner-function.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { Observable } from 'rxjs/Rx';
import { FormControl, Validators } from '@angular/forms';
import { validation } from '../../../util/validation';

@Component({
  selector: 'wa5011',
  templateUrl: './wa5011.component.html',
  styleUrls: ['./wa5011.component.scss']
})
export class Wa5011Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  private moveGridApi: any;
  private registerGridApi: any;
  public componentTitle = 'WA5011:指示登録/引当';
  private updprogramCd = 'wa5011';

  public gridOptionsMovingSource: GridOptions;
  public gridOptionsGotoSource: GridOptions;
  public gridOptionsRegistered: GridOptions;

  public rowDataMovingSource: any[];
  public rowDataGotoSource: any[];
  public rowDataRegistered: any[];

  public showGrid: boolean;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 800;
  public gridHeight = 500;
  public lowCardContentHeight = 800;
  public production = environment.production;
  public backgroundColor: string;
  public errorInfo: string = '';

  public windowSize = '';

  public selected = 0;

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  public validation = validation;

  /** Start MovingSource */
  private isShowChooseItemForMoving = false;
  private isMovingSourceFetched = false;
  private gridHelperForMoving: AgGridHelper;
  private isEnableClearFilterButtonForMoving = false;
  private totalCountForMovingGrid = 0;
  private selectedCountForMovingGrid = 0;
  @ViewChild('gridViewForMoving')
  gridViewForMoving: ElementRef;
  private movingGridHeight = 325;
  private currentPageForMovingGrid = 0;
  private maxPageForMovingGrid = 0;
  public rowsPerPageModel = [{ value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }, { value: 1000, viewValue: '1000' }];
  public rowsPerPage = this.rowsPerPageModel[0].value;

  private gridSearchKeyForMovingLocaTx = null;
  private gridSearchKeyForMovingLocaBlockTx = '';
  private gridSearchKeyForMovingItemCd = null;
  private gridSearchKeyForMovingStockType = '';

  /** SWMS-2900 移動元・荷主絞り込み */
  public owners: any[] = [];
  public selectedownerId = null;
  public gridSearchKeyForMovingOwnerId = null;
  public selectedOwnerTx = '';

  private movingSourceData = null;

  public movingCaseValue: FormControl;
  public movingInnerValue: FormControl;
  public movingBaseValue: FormControl;

  private movingUpdstockNr: String = '';
  private isMovingSourceBlockOpen = false;
  /** End MovingSource */

  /** Start Source */
  private isShowChooseItemForSource = false;
  private gridHelperForSource: AgGridHelper;
  private isEnableClearFilterButtonForSource = false;
  private totalCountForSourceGrid = 0;
  private selectedCountForSourceGrid = 0;
  @ViewChild('gridViewForSource')
  gridViewForSource: ElementRef;
  private sourceGridHeight = 300;
  private isSourceBlockOpen = false;
  private currentPageForSourceGrid = 0;
  private maxPageForSourceGrid = 0;
  public sourceRowsPerPageModel = [{ value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }, { value: 1000, viewValue: '1000' }];
  public sourceRowsPerPage = this.rowsPerPageModel[0].value;

  private gridSearchKeyForSourceLocaCd = null;
  private gridSearchKeyForSourceLocaTx = null;
  private gridSearchKeyForSourceLocaBlockTx = '';
  private gridSearchKeyForSourceStockTypeTx = '';
  private gridSearchKeyForSourceItemCd = null;
  private gridSearchKeyForSourceItemTx = null;

  private gotoSourceData = null;
  private isAllowSourceAppend = false;
  /** End Goto Source */

  /** Register block */
  private isRegisterBlockOpen = false;
  private gridHelperForRegister: AgGridHelper;
  @ViewChild('gridViewForRegister')
  gridViewForRegister: ElementRef;
  private isEnableRegisterSubmitButton = false;
  /** End Register block */

  private stockTypes: any[];
  private stockType: null;

  private locaBlocks: any[];

  private gridSearchKeyForMovingLocaTxCls = '';
  private gridSearchKeyForMovingLocaBlockTxCls = '';
  private gridSearchKeyForMovingItemCdCls = '';
  private gridSearchKeyForMovingStockTypeCls = '';

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  private gridSearchKeyForSourceLocaCdCls = '';
  private gridSearchKeyForSourceLocaTxCls = '';
  private gridSearchKeyForSourceLocaBlockTxCls = '';
  private gridSearchKeyForSourceStockTypeTxCls = '';
  private gridSearchKeyForSourceItemCdCls = '';
  private gridSearchKeyForSourceItemTxCls = '';

  private movingCaseValueCls = '';
  private movingInnerValueCls = '';
  private movingBaseValueCls = '';
  private ownerFunctions = []
  private isShowConfirmInstockDialog = false

  constructor(
    private router: Router,
    private moveService: MoveService,
    private locaStockService: LocaStockService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    public changeDetectorRef: ChangeDetectorRef,
    private typeStockService: TypeStockService,
    private locaBlockService: LocaBlockService,
    private ownerFunctionService: OwnerFunctionService,
    private ownerService: OwnerService
  ) {
    this.onMovingSource();
    this.onGotoSource();
    this.onRegistered();
    this.loadLocaBlock();

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.lowCardContentHeight = this.cardHeight - 280;

    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.movingGridHeight = this.gridHeight - 200;
    ownerFunctionService.getOwnerFunctions()
      .then(res => {
        this.ownerFunctions = res.ownerFunctions
      })
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa5011_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa5011_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder(gridname: string, gridApi: any) {
    let idx = 0;
    for (const column of gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa5011_${gridname}_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  onResize(event) {
    // this.windowSize = '高さ: ' + window.outerHeight + ' / 横幅: ' + window.outerWidth;
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.lowCardContentHeight = this.cardHeight - 260;
    console.log('cardHeight: ' + this.cardHeight);
    console.log('lowCardContentHeight: ' + this.lowCardContentHeight);
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
    this.movingGridHeight = this.gridHeight - 200;
  }

  ngAfterViewInit() {
    this.gridHelperForSource.el = this.gridViewForSource;
    this.gridHelperForMoving.el = this.gridViewForMoving;
    this.gridHelperForRegister.el = this.gridViewForRegister;
    /*
    var movingAreaHeight = this.gridHelperForMoving.getElementHeight(this.gridViewForMoving.nativeElement);
    this.gridViewForMoving.nativeElement.querySelector('.ag-body-viewport').style.height = movingAreaHeight - 60 + 'px';

    this.movingGridHeight = movingAreaHeight - 60;
    */
    /*
    setTimeout(() => {
      this.onSubmitMovingSource();
    }, 500);
    */
  }

  onMovingSource() {
    this.movingCaseValue = new FormControl('', [Validators.pattern(validation.integer), Validators.pattern(validation.integerPlus)]);
    this.movingInnerValue = new FormControl('', [Validators.pattern(validation.integer), Validators.pattern(validation.integerPlus)]);
    this.movingBaseValue = new FormControl('', [Validators.pattern(validation.integer), Validators.pattern(validation.integerPlus)]);
    this.movingCaseValue.disable();
    this.movingInnerValue.disable();
    this.movingBaseValue.disable();

    this.gridHelperForMoving = new AgGridHelper();
    this.gridHelperForMoving.gridSelectionCheckboxStyle = 'radio';
    this.gridOptionsMovingSource = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: false,
      localeText: environment.gridLocale,
      onColumnResized: this.saveColumnWidth,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      suppressRowClickSelection: false,
      showLoadingOverlay: true,
      // domLayout: "autoHeight",
      onColumnMoved: () => {
        this.saveColumnOrder('movingsource', this.moveGridApi);
      },
      /*
      onRowSelected: param => {
        this.onRowSelectedMovingSource(event);
      },
      */
      onGridReady: params => {
        this.moveGridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa5011_movingsource_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelperForMoving.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButtonForMoving = this.gridOptionsMovingSource.api.isAnyFilterPresent();
        this.gridHelperForMoving.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.searchMovingByKey();
        this.selectedCountForMovingGrid = this.gridOptionsMovingSource.api.getSelectedRows().length;
        this.gridHelperForMoving.onRowDataChanged();
        this.errorInfo = '';

        if (this.gridOptionsMovingSource.rowData && this.gridOptionsMovingSource.rowData.length > 0) this.gridHelperForMoving.isShowGridNoDataOverlay = false;
        else this.gridHelperForMoving.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelperForMoving.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelperForMoving.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelperForMoving.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelperForMoving.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCountForMovingGrid = this.gridOptionsMovingSource.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.totalCountForMovingGrid = this.gridOptionsMovingSource.api.paginationGetRowCount();
        this.maxPageForMovingGrid = this.gridOptionsMovingSource.api.paginationGetTotalPages();
        this.currentPageForMovingGrid = this.gridOptionsMovingSource.api.paginationGetCurrentPage() + 1;
        this.gridHelperForMoving.renderGridCheckboxImage();
      },
      onCellClicked: param => {
        console.log(' on cell click')
        var cols = param.colDef.field;
        var index = param.rowIndex;
        const { node } = param
        // var node = this.gridOptionsMovingSource.api.getRowNode(index);
        // if (cols == 'checkbox') {
        //   console.log(' on cell click1')
        //   if (node.isSelected()) {
        //     node.setSelected(false);
        //   } else {
        //     node.setSelected(true);
        //   }
        // }
        node.setSelected(this.isMovingSourceItemSelectable(node));
      }
    };
    this.gridOptionsMovingSource.columnDefs = [
      {
        field: 'checkbox',
        headerName: '',
        // headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        // checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left',
        checkboxSelection: (params) => {
          const { node } = params
          return this.isMovingSourceItemSelectable(node)
        }
      },
      {
        headerName: 'ロケーション名',
        field: 'locaTx',
        sort: 'asc',
        width: this.getColumnWidth('locaTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: 'ロケブロック名',
        field: 'locablockTx',
        width: this.getColumnWidth('locablockTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '温度帯',
        field: 'typecoldTx',
        width: this.getColumnWidth('typecoldTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: 'ピースバーコード',
        field: 'pcsbarcodeTx',
        width: this.getColumnWidth('pcsbarcodeTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: 'ケースバーコード',
        field: 'casebarcodeTx',
        width: this.getColumnWidth('casebarcodeTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '入庫日',
        field: 'stockDt',
        width: this.getColumnWidth('stockDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      /*
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 100)
      },*/
      {
        headerName: 'ｹｰｽ入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: 'ｲﾝﾅｰｹｰｽ入数',
        field: 'inneramountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '在庫数(ｹｰｽ)',
        field: 'stockcaseNr',
        width: this.getColumnWidth('stockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '在庫数(ｲﾝﾅｰｹｰｽ)',
        field: 'stockinnerNr',
        width: this.getColumnWidth('stockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '在庫数(ﾊﾞﾗ)',
        field: 'stockpcsNr',
        width: this.getColumnWidth('stockpcsNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        width: this.getColumnWidth('stockNr', 140),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当可能数(ｹｰｽ)',
        field: 'pstockcaseNr',
        width: this.getColumnWidth('pstockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当可能数(ｲﾝﾅｰｹｰｽ)',
        field: 'pstockinnerNr',
        width: this.getColumnWidth('pstockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当可能数(ﾊﾞﾗ)',
        field: 'pstockpcsNr',
        width: this.getColumnWidth('pstockpcsNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当可能数',
        field: 'pstockNr',
        width: this.getColumnWidth('pstockNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当済数(ｹｰｽ)',
        field: 'cstockcaseNr',
        width: this.getColumnWidth('cstockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当済数(ｲﾝﾅｰｹｰｽ)',
        field: 'cstockinnerNr',
        width: this.getColumnWidth('cstockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当済数(ﾊﾞﾗ)',
        field: 'cstockpcsNr',
        width: this.getColumnWidth('cstockpcsNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当済数',
        field: 'cstockNr',
        width: this.getColumnWidth('cstockNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '荷主ID',
        field: 'ownerId',
        width: this.getColumnWidth('ownerId', 0),
        hide: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: 'ロケーション',
        field: 'locaCd',
        width: this.getColumnWidth('locaCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '引当不可フラグ',
        field: 'notapplyFl',
        width: this.getColumnWidth('notapplyFl', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      {
        headerName: '備考',
        field: 'stockmemotTx',
        width: this.getColumnWidth('stockmemotTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        cellStyle: this.movingSourceCellStyle.bind(this)
      },
      // 集約して表示するため、管理項目は表示できない
      {
        field: 'locaId',
        hide: true
      },
      {
        field: 'itemunitId',
        hide: true
      },
      {
        // headerName: 'ロット混在フラグ',
        field: 'mixlotFl',
        hide: true
      },
      {
        field: 'locasplitNr',
        hide: true
      }
    ];
    this.gridHelperForMoving.setGridOptions(this.gridOptionsMovingSource);
  }

  onSubmitMovingSource() {
    // this.working = true;
    setTimeout(() => {
      this.gridHelperForMoving.insertLoadingOverlay()
    })

    this.locaStockService
      .getMoveSrc(1, 0)
      .then(outputJson => {
        this.working = false;
        console.log('onSubmitMovingSource');
        // console.log(JSON.stringify(outputJson));
        this.isMovingSourceFetched = true;
        this.rowDataMovingSource = outputJson.locastocks;
        /*
        Observable.timer(100).subscribe(() => {
          this.searchMovingByKey();
        });
        */
      })
      .catch(error => {
        this.working = false;
        // console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onRowSelectedMovingSource(event) {
    if (this.gridOptionsMovingSource.api.getSelectedNodes()[0] === undefined) {
      return;
    }

    this.onSubmitGotoSource();

    this.onTabFocus(1);
  }

  onGotoSource() {
    this.gridHelperForSource = new AgGridHelper();
    this.gridHelperForSource.gridSelectionCheckboxStyle = 'radio';
    this.gridOptionsGotoSource = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      // enableRangeSelection: true,
      localeText: environment.gridLocale,
      onColumnResized: this.saveColumnWidth,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      suppressRowClickSelection: false,
      showLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder('gotosource', this.gridApi);
      },
      /*
      onRowSelected: () => {
        this.onRowSelectedGotoSource(event);
      },
      */
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa5011_gotosource_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelperForSource.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButtonForSource = this.gridOptionsGotoSource.api.isAnyFilterPresent();
        this.gridHelperForSource.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.searchSourceByKey();
        this.selectedCountForSourceGrid = this.gridOptionsGotoSource.api.getSelectedRows().length;
        this.gridHelperForSource.onRowDataChanged();
        this.errorInfo = '';

        if (this.gridOptionsGotoSource.rowData && this.gridOptionsGotoSource.rowData.length > 0) this.gridHelperForSource.isShowGridNoDataOverlay = false;
        else this.gridHelperForSource.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelperForSource.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelperForSource.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelperForSource.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelperForSource.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onSelectionChanged: () => {
        this.selectedCountForSourceGrid = this.gridOptionsGotoSource.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.totalCountForSourceGrid = this.gridOptionsGotoSource.api.paginationGetRowCount();
        this.maxPageForSourceGrid = this.gridOptionsGotoSource.api.paginationGetTotalPages();
        this.currentPageForSourceGrid = this.gridOptionsGotoSource.api.paginationGetCurrentPage() + 1;
        this.gridHelperForSource.renderGridCheckboxImage();
      },
      onCellClicked: param => {
        var cols = param.colDef.field;
        var index = param.rowIndex;
        if (cols == 'checkbox') {
          var node = this.gridOptionsGotoSource.api.getRowNode(index);
          if (node.isSelected()) {
            node.setSelected(false);
          } else {
            node.setSelected(true);
          }
        }
      }
    };
    this.gridOptionsGotoSource.columnDefs = [
      {
        headerName: '',
        // headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'noCellFocus']
      },
      {
        headerName: 'ロケーション名',
        field: 'locaTx',
        sort: 'asc',
        width: this.getColumnWidth('locaTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケブロック名',
        field: 'locablockTx',
        width: this.getColumnWidth('locablockTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '温度帯',
        field: 'typecoldTx',
        width: this.getColumnWidth('typecoldTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ピースバーコード',
        field: 'pcsbarcodeTx',
        width: this.getColumnWidth('pcsbarcodeTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ケースバーコード',
        field: 'casebarcodeTx',
        width: this.getColumnWidth('casebarcodeTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入庫日',
        field: 'stockDt',
        width: this.getColumnWidth('stockDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      /*
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 100)
      },
      */
      {
        headerName: 'ｹｰｽ入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ｲﾝﾅｰｹｰｽ入数',
        field: 'inneramountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫数(ｹｰｽ)',
        field: 'stockcaseNr',
        width: this.getColumnWidth('stockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫数(ｲﾝﾅｰｹｰｽ)',
        field: 'stockinnerNr',
        width: this.getColumnWidth('stockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫数(ﾊﾞﾗ)',
        field: 'stockpcsNr',
        width: this.getColumnWidth('stockpcsNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        width: this.getColumnWidth('stockNr', 140),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当可能数(ｹｰｽ)',
        field: 'pstockcaseNr',
        width: this.getColumnWidth('pstockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当可能数(ｲﾝﾅｰｹｰｽ)',
        field: 'pstockinnerNr',
        width: this.getColumnWidth('pstockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当可能数(ﾊﾞﾗ)',
        field: 'pstockpcsNr',
        width: this.getColumnWidth('pstockpcsNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当可能数',
        field: 'pstockNr',
        width: this.getColumnWidth('pstockNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当済数(ｹｰｽ)',
        field: 'cstockcaseNr',
        width: this.getColumnWidth('cstockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当済数(ｲﾝﾅｰｹｰｽ)',
        field: 'cstockinnerNr',
        width: this.getColumnWidth('cstockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当済数(ﾊﾞﾗ)',
        field: 'cstockpcsNr',
        width: this.getColumnWidth('cstockpcsNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当済数',
        field: 'cstockNr',
        width: this.getColumnWidth('cstockNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション',
        field: 'locaCd',
        width: this.getColumnWidth('locaCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当不可フラグ',
        field: 'notapplyFl',
        width: this.getColumnWidth('notapplyFl', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '備考',
        field: 'stockmemotTx',
        width: this.getColumnWidth('stockmemotTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      // 集約して表示するため、管理項目は表示できない
      {
        field: 'locaId',
        hide: true
      },
      {
        field: 'itemunitId',
        hide: true
      },
      {
        // headerName: '在庫区分コード',
        field: 'typestockCd',
        hide: true
      }
    ];
    this.gridHelperForSource.setGridOptions(this.gridOptionsGotoSource);
  }

  onSubmitGotoSource() {
    // this.working = true;

    setTimeout(() => {
      this.gridHelperForSource.insertLoadingOverlay()
    })

    if (this.movingSourceData.mixlotFl === 0) {
      this.locaStockService
        .getMoveDest(this.movingSourceData.itemId, this.movingSourceData.locaId, this.movingSourceData.lotTx)
        .then(outputJson => {
          this.working = false;
          console.log('onSubmitMovingSource');
          // console.log(JSON.stringify(outputJson));
          this.rowDataGotoSource = outputJson.locastocks;
        })
        .catch(error => {
          this.working = false;
          // console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    } else {
      this.locaStockService
        .getMoveDest(this.movingSourceData.itemId, this.movingSourceData.locaId, undefined)
        .then(outputJson => {
          this.working = false;
          console.log('onSubmitMovingSource');
          // console.log(JSON.stringify(outputJson));
          this.rowDataGotoSource = outputJson.locastocks;
        })
        .catch(error => {
          this.working = false;
          // console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
  }

  onRegistered() {
    this.gridHelperForRegister = new AgGridHelper();
    this.gridOptionsRegistered = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      suppressRowClickSelection: false,
      domLayout: 'autoHeight',
      onColumnMoved: () => {
        this.saveColumnOrder('registered', this.registerGridApi);
      },
      onGridReady: params => {
        this.registerGridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa5011_registered_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelperForRegister.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButtonForSource = this.gridOptionsRegistered.api.isAnyFilterPresent();
        this.gridHelperForRegister.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.gridHelperForRegister.onRowDataChanged();
        this.errorInfo = '';

        if (this.gridOptionsRegistered.rowData && this.gridOptionsRegistered.rowData.length > 0) this.gridHelperForRegister.isShowGridNoDataOverlay = false;
        else this.gridHelperForRegister.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelperForRegister.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelperForRegister.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelperForRegister.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelperForRegister.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onCellClicked: param => {
        var cols = param.colDef.field;
        var index = param.rowIndex;
        if (cols == 'checkbox') {
          var node = this.gridOptionsRegistered.api.getRowNode(index);
          if (node.isSelected()) {
            node.setSelected(false);
          } else {
            node.setSelected(true);
          }
        }
      },
      onSelectionChanged: () => {
        this.isEnableRegisterSubmitButton = this.gridOptionsRegistered.api.getSelectedRows().length > 0;
      },
      onPaginationChanged: () => {
        this.isEnableRegisterSubmitButton = false;
        this.gridHelperForRegister.renderGridCheckboxImage();
      }
    };
    this.gridOptionsRegistered.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelectionFilteredOnly: true,
        width: 40,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        headerCheckboxSelection: true,
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主ID',
        field: 'ownerId',
        width: this.getColumnWidth('ownerId', 0),
        hide: true
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '論理倉庫ID',
        field: 'logicalwhId',
        width: this.getColumnWidth('logicalwhId', 0),
        hide: true
      },
      {
        headerName: '商品コード',
        field: 'srcItemCd',
        width: this.getColumnWidth('itemCd', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'srcItemTx',
        width: this.getColumnWidth('itemTx', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        field: 'srcUselimitDt',
        width: this.getColumnWidth('uselimitDt', 120),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'srcLotTx',
        width: this.getColumnWidth('lotTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ケース入数',
        field: 'srcAmountNr',
        width: this.getColumnWidth('amountNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: 'ｲﾝﾅｰｹｰｽ入数',
        field: 'srcInnerAmountNr',
        width: this.getColumnWidth('amountNr', 80),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '移動数(ｹｰｽ)',
        field: 'moveCaseNr',
        width: this.getColumnWidth('movecaseNr', 120),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '移動数(ｲﾝﾅｰｹｰｽ)',
        field: 'moveInnerNr',
        width: this.getColumnWidth('moveinnerNr', 120),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '移動数(ﾊﾞﾗ)',
        field: 'moveBaraNr',
        width: this.getColumnWidth('movebaraNr', 120),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '移動数',
        field: 'movePcsNr',
        width: this.getColumnWidth('movepcsNr', 120),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '元ロケ・ロケーションコード',
        field: 'srcLocaCd',
        width: this.getColumnWidth('srclocaCd', 200),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '元ロケ',
        field: 'srcLocaTx',
        width: this.getColumnWidth('srclocaTx', 120),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '元ロケ・在庫区分',
        field: 'srcTypestockTx',
        width: this.getColumnWidth('srctypestockTx', 140),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '先ロケ・ロケーションコード',
        field: 'destLocaCd',
        width: this.getColumnWidth('destlocaCd', 200),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '先ロケ',
        field: 'destLocaTx',
        width: this.getColumnWidth('destlocaTx', 120),
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '先ロケ・在庫区分',
        field: 'destTypestockTx',
        width: this.getColumnWidth('desttypestockTx', 140),
        cellClass: ['tr', 'cellclass']
      },
      {
        // headerName: '元ロケ・在庫区分コード',
        field: 'srcTypestockCd',
        hide: true
      },
      {
        // headerName: '先ロケ・在庫区分コード',
        field: 'destTypestockCd',
        hide: true
      }
    ];
    this.gridHelperForRegister.setGridOptions(this.gridOptionsRegistered);
  }

  onSubmitRegistered() {
    this.errorInfo = '';
    this.working = true;
    this.isEnableRegisterSubmitButton = false;
    let baseJson: string[] = new Array();

    if (this.gridOptionsRegistered.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
      this.isEnableRegisterSubmitButton = true;
    } else {
      const result = sessionStorage.getItem('loginResult');
      const resultObject = JSON.parse(result);
      const user = resultObject.user;

      var submitLength = this.gridOptionsRegistered.api.getSelectedNodes().length;
      for (let i = 0; i < this.gridOptionsRegistered.api.getSelectedNodes().length; i++) {
        const selectedData = this.gridOptionsRegistered.api.getSelectedNodes()[i].data;
        // this.gridOptionsRegistered.api.updateRowData({remove: [selectedData]});

        if (selectedData.srcUselimitDt === '') {
          selectedData.srcUselimitDt = '2099-01-01';
        }
        selectedData.srcmoveuserId = user.userId;
        selectedData.srcmoveuserCd = user.userTx;
        selectedData.srcStockDt = selectedData.srcStockDt.replace(/\//g, '-')
        selectedData.srcUselimitDt = selectedData.srcUselimitDt.replace(/\//g, '-')
        console.log(selectedData);
        baseJson.push(selectedData);
      }

      this.moveService
        .save(JSON.stringify(baseJson))
        .then(outputJson => {
          // this.gridOptionsRegistered.api.setRowData([]);
          for (let i = 0; i < baseJson.length; i++) {
            this.gridOptionsRegistered.api.updateRowData({ remove: [baseJson[i]] });
          }
          this.working = false;
          this.isEnableRegisterSubmitButton = true;
          sessionStorage.setItem('SuccessInfoMessage', submitLength + '件の移動指示を作成しました。');
        })
        .catch(error => {
          console.log(error);
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.working = false;
          this.isEnableRegisterSubmitButton = true;
        });
    }
  }

  onDeleteRegistered() {
    if (this.gridOptionsRegistered.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.working = false;
    } else {
      for (let i = 0; i < this.gridOptionsRegistered.api.getSelectedNodes().length; i++) {
        const selectedData = this.gridOptionsRegistered.api.getSelectedNodes()[i].data;
        this.gridOptionsRegistered.api.updateRowData({ remove: [selectedData] });
      }
    }
  }

  onTabFocus(index) {
    this.selected = index;
    console.log(index);
  }

  doTabClick(val: number) {
    console.log(val);
    setTimeout(() => {
      this.changeDetectorRef.detectChanges();
    }, 10000);
  }

  onMoveBackSubmit() {
    this.dialogsService.confirm('確認', '指示確定をしていないデータは、初期化されます。戻ってもよろしいですか？').subscribe(res => {
      if (res === true) {
        this.working = true;
        this.router.navigate(['wa5010']);
      }
    });
  }

  loadLocaBlock() {
    this.locaBlockService
      .get()
      .then(response => {
        this.locaBlocks = response['locablocks'];
      })
      .catch(error => {
        this.locaBlocks = [];
      });
  }

  /**
   * SWMS-2900 移動元の荷主絞り込み用の荷主一覧を取得する。
   * 商品マスタ登録(wa9101)と同仕様で、荷主選択状態で開いた場合はその荷主に固定し、
   * 未選択で開いた場合はセレクトボックスで選択できるようにする。
   */
  loadOwners() {
    this.ownerService
      .get()
      .then(outputJson => {
        try {
          const ownerResult = JSON.parse(sessionStorage.getItem('ownerResult'));
          if (ownerResult !== null && ownerResult.ownerId !== undefined) {
            // 荷主選択状態で開いた場合 → 当該荷主に固定（セレクトボックスは非活性表示）
            this.owners = outputJson.owners.filter(item => item.ownerId === ownerResult.ownerId);
            this.selectedownerId = ownerResult.ownerId;
            this.selectedOwnerTx = ownerResult.ownerTx;
            this.gridSearchKeyForMovingOwnerId = this.owners.length > 0 ? this.owners[0].ownerId : null;
          } else {
            // 未選択で開いた場合 → セレクトボックスで選択
            this.owners = outputJson.owners;
            this.selectedownerId = null;
            this.selectedOwnerTx = '';
            this.gridSearchKeyForMovingOwnerId = null;
          }
        } catch (error) {
          this.owners = outputJson.owners;
          this.selectedownerId = null;
          this.selectedOwnerTx = '';
          this.gridSearchKeyForMovingOwnerId = null;
        }
      })
      .catch(error => {
        this.owners = [];
        this.selectedownerId = null;
        this.selectedOwnerTx = '';
        this.gridSearchKeyForMovingOwnerId = null;
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.isMovingSourceBlockOpen = true;
      this.rowDataRegistered = [];
      this.loadOwners();
      this.typeStockService
        .get()
        .then(response => {
          console.log(response);
          this.stockTypes = response['typestocks'];
        })
        .catch(error => {
          this.stockTypes = [];
        });

      setTimeout(() => {
        //this.onSubmit();
      }, 500);
    }
    else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  close5011() {
    this.onRegisterCancel();

    this.rowDataRegistered = [];
    this.closeButtonClick.emit(true);
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }
  /** Choose Item - Moving */
  showChooseItemForMoving() {
    this.errorInfo = '';
    this.isShowChooseItemForMoving = true;
    this.clearMovingSearchKey();
    this.clearMovingFilter();
    // SWMS-2900 荷主固定モードで開いた際、データ未取得の空グリッドに荷主フィルタが適用され
    // 「検索条件に一致する項目はありません」と誤表示されるため、取得前はフィルタ適用をスキップする
    this.isMovingSourceFetched = false;
    this.rowDataMovingSource = [];
    setTimeout(() => {
      const overlay = this.gridHelperForMoving.el.nativeElement.querySelector('.ag-bl-overlay')
      overlay.style.display = 'none'
    }, 200)
  }
  closeChooseItemForMovingSource() {
    this.errorInfo = '';
    this.isShowChooseItemForMoving = false;
  }

  clearMovingFilter() {
    this.errorInfo = '';
    this.gridOptionsMovingSource.api.setFilterModel(null);
  }
  clearMovingSearchKey() {
    this.errorInfo = '';
    this.gridSearchKeyForMovingLocaTx = null;
    this.gridSearchKeyForMovingLocaBlockTx = '';
    this.gridSearchKeyForMovingItemCd = null;
    this.gridSearchKeyForMovingStockType = '';
    // SWMS-2900 荷主選択状態で開いた場合は固定の荷主絞り込みを維持する
    if (this.selectedownerId == null) {
      this.gridSearchKeyForMovingOwnerId = null;
    }
  }

  clearMovingAndSubmit() {
    this.errorInfo = '';
    this.clearMovingFilter();
    this.onSubmitMovingSource();
  }

  searchMovingByKey() {
    this.errorInfo = '';
    // SWMS-2900 データ未取得の空グリッドにフィルタを適用すると
    // 「検索条件に一致する項目はありません」と誤表示されるため、取得完了前は何もしない
    if (!this.isMovingSourceFetched) return;
    var filters = {};
    if (this.gridSearchKeyForMovingLocaTx != null && this.gridSearchKeyForMovingLocaTx.length > 0) {
      filters['locaTx'] = {
        type: 'contains',
        filter: this.gridSearchKeyForMovingLocaTx
      };
    }

    if (this.gridSearchKeyForMovingLocaBlockTx != null && this.gridSearchKeyForMovingLocaBlockTx.length > 0) {
      let filterStr = this.locaBlocks[this.gridSearchKeyForMovingLocaBlockTx]['locablockTx'];
      filters['locablockTx'] = {
        type: 'contains',
        filter: filterStr
      };
    }

    if (this.gridSearchKeyForMovingItemCd != null && this.gridSearchKeyForMovingItemCd.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.gridSearchKeyForMovingItemCd
      };
    }

    if (this.gridSearchKeyForMovingStockType != null && this.gridSearchKeyForMovingStockType.length > 0) {
      let filterStr = this.stockTypes[this.gridSearchKeyForMovingStockType]['typestockTx'];
      filters['typestockTx'] = {
        type: 'contains',
        filter: filterStr
      };
    }

    // SWMS-2900 荷主による絞り込み（誤って別荷主の在庫を選択しないようにする）
    // 荷主コードは一意保証がないため、内部IDのownerIdで絞り込む
    if (this.gridSearchKeyForMovingOwnerId != null) {
      filters['ownerId'] = {
        type: 'equals',
        filter: this.gridSearchKeyForMovingOwnerId
      };
    }
    this.moveGridApi.api.setFilterModel(null);
    if (Object.getOwnPropertyNames(filters).length == 0) return;
    console.log(filters);
    this.moveGridApi.api.setFilterModel(filters);
  }

  onMovingItemSelectButtonClick() {

    this.errorInfo = '';
    if (this.selectedCountForMovingGrid == 0) return;
    var node = this.gridOptionsMovingSource.api.getSelectedNodes()[0];
    console.log(node);

    this.isSourceBlockOpen = true;
    this.movingSourceData = node.data;
    this.movingBaseValue.enable();
    this.movingCaseValue.enable();
    this.movingInnerValue.enable();

    this.closeChooseItemForMovingSource();
  }

  onSumStock() {
    this.errorInfo = '';
    /*
    if (this.movingCaseValue.value.length == 0 || this.movingBaseValue.value.length == 0) {
      this.movingUpdstockNr = '';
      return;
    }
    this.movingUpdstockNr = '0';

    var nr = 0;
    if (this.movingCaseValue.value.length > 0)
      nr = parseInt(this.movingCaseValue.value) * this.movingSourceData.amountNr;

    if (this.movingBaseValue.value.length > 0)
      nr += parseInt(this.movingBaseValue.value);

    this.movingUpdstockNr = nr + '';
    this.checkSourceAppendButtonState();
    */
  }

  ngDoCheck() {
    if (!this.isShow)
      return;
    this.movingUpdstockNr = '';

    var nr = 0;
    if (this.movingSourceData != null) {

      if (this.movingCaseValue.value != null)
        nr = this.movingCaseValue.value * this.movingSourceData.caseamountNr;

      if (this.movingInnerValue.value != null)
        nr += this.movingInnerValue.value * this.movingSourceData.inneramountNr;

      if (this.movingBaseValue.value != null)
        nr += this.movingBaseValue.value;

      this.movingUpdstockNr = nr + '';
    }

    this.gridSearchKeyForMovingLocaTxCls = this.gridSearchKeyForMovingLocaTx != null && this.gridSearchKeyForMovingLocaTx.length > 0 ? 'active' : '';
    this.gridSearchKeyForMovingLocaBlockTxCls = this.gridSearchKeyForMovingLocaBlockTx != null && this.gridSearchKeyForMovingLocaBlockTx.length > 0 ? 'active' : '';
    this.gridSearchKeyForMovingItemCdCls = this.gridSearchKeyForMovingItemCd != null && this.gridSearchKeyForMovingItemCd.length > 0 ? 'active' : '';
    this.gridSearchKeyForMovingStockTypeCls = this.gridSearchKeyForMovingStockType != null && this.gridSearchKeyForMovingStockType.length > 0 ? 'active' : '';

    this.gridSearchKeyForSourceLocaCdCls = this.gridSearchKeyForSourceLocaCd != null && this.gridSearchKeyForSourceLocaCd.length > 0 ? 'active' : '';
    this.gridSearchKeyForSourceLocaTxCls = this.gridSearchKeyForSourceLocaTx != null && this.gridSearchKeyForSourceLocaTx.length > 0 ? 'active' : '';
    this.gridSearchKeyForSourceLocaBlockTxCls = this.gridSearchKeyForSourceLocaBlockTx != null && this.gridSearchKeyForSourceLocaBlockTx.length > 0 ? 'active' : '';
    this.gridSearchKeyForSourceStockTypeTxCls = this.gridSearchKeyForSourceStockTypeTx != null && this.gridSearchKeyForSourceStockTypeTx.length > 0 ? 'active' : '';
    this.gridSearchKeyForSourceItemCdCls = this.gridSearchKeyForSourceItemCd != null && this.gridSearchKeyForSourceItemCd.length > 0 ? 'active' : '';
    this.gridSearchKeyForSourceItemTxCls = this.gridSearchKeyForSourceItemTx != null && this.gridSearchKeyForSourceItemTx.length > 0 ? 'active' : '';

    this.movingCaseValueCls = this.movingSourceData == null ? 'disabled' : this.movingCaseValue.errors == null ? (this.movingCaseValue.value != null && (this.movingCaseValue.value + '').length > 0 ? 'active' : '') : 'error';
    this.movingInnerValueCls = this.movingSourceData == null ? 'disabled' : this.movingInnerValue.errors == null ? (this.movingInnerValue.value != null && (this.movingInnerValue.value + '').length > 0 ? 'active' : '') : 'error';
    this.movingBaseValueCls = this.movingSourceData == null ? 'disabled' : this.movingBaseValue.errors == null ? (this.movingBaseValue.value != null && (this.movingBaseValue.value + '').length > 0 ? 'active' : '') : 'error';

    this.checkSourceAppendButtonState();
  }

  /** Choose Item - Source */
  showChooseItemForSource() {
    this.errorInfo = '';
    this.isShowChooseItemForSource = true;
    this.clearSourceSearchKey();
    this.clearSourceFilter();
    this.rowDataGotoSource = [];
    setTimeout(() => {
      const overlay = this.gridHelperForSource.el.nativeElement.querySelector('.ag-bl-overlay')
      overlay.style.display = 'none'
    }, 200)
  }
  closeChooseItemForSource() {
    this.errorInfo = '';
    this.isShowChooseItemForSource = false;
  }
  closeSourceBlock() {
    this.errorInfo = '';
    this.isMovingSourceBlockOpen = true;
    this.isSourceBlockOpen = false;
    this.movingSourceData = null;
    this.gotoSourceData = null;
    this.isAllowSourceAppend = false;
    this.movingUpdstockNr = '';
    this.movingBaseValue.setValue('');
    this.movingCaseValue.setValue('');
    this.movingInnerValue.setValue('');
    this.movingBaseValue.disable();
    this.movingCaseValue.disable();
    this.movingInnerValue.disable();
  }

  clearSourceSearchKey() {
    this.errorInfo = '';
    this.gridSearchKeyForSourceLocaCd = null;
    this.gridSearchKeyForSourceLocaTx = '';
    this.gridSearchKeyForSourceLocaBlockTx = null;
    this.gridSearchKeyForSourceStockTypeTx = '';
    this.gridSearchKeyForSourceItemCd = null;
    this.gridSearchKeyForSourceItemTx = null;
  }

  clearSourceFilter() {
    this.errorInfo = '';
    this.gridOptionsGotoSource.api.setFilterModel(null);
  }
  clearSourceAndSubmit() {
    this.errorInfo = '';
    this.clearSourceFilter();
    this.onSubmitGotoSource();
  }

  searchSourceByKey() {
    this.errorInfo = '';
    var filters = {};
    if (this.gridSearchKeyForSourceLocaCd != null && this.gridSearchKeyForSourceLocaCd.length > 0) {
      filters['locaCd'] = {
        type: 'contains',
        filter: this.gridSearchKeyForSourceLocaCd
      };
    }

    if (this.gridSearchKeyForSourceLocaTx != null && this.gridSearchKeyForSourceLocaTx.length > 0) {
      filters['locaTx'] = {
        type: 'contains',
        filter: this.gridSearchKeyForSourceLocaTx
      };
    }

    if (this.gridSearchKeyForSourceLocaBlockTx != null && this.gridSearchKeyForSourceLocaBlockTx.length > 0) {
      let filterStr = this.locaBlocks[this.gridSearchKeyForSourceLocaBlockTx]['locablockTx'];
      filters['locablockTx'] = {
        type: 'contains',
        filter: filterStr
      };
    }

    if (this.gridSearchKeyForSourceStockTypeTx != null && this.gridSearchKeyForSourceStockTypeTx.length > 0) {
      let filterStr = this.stockTypes[this.gridSearchKeyForSourceStockTypeTx]['typestockTx'];
      filters['typestockTx'] = {
        type: 'contains',
        filter: filterStr
      };
    }

    if (this.gridSearchKeyForSourceItemCd != null && this.gridSearchKeyForSourceItemCd.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.gridSearchKeyForSourceItemCd
      };
    }

    if (this.gridSearchKeyForSourceItemTx != null && this.gridSearchKeyForSourceItemTx.length > 0) {
      filters['itemTx'] = {
        type: 'contains',
        filter: this.gridSearchKeyForSourceItemTx
      };
    }
    this.gridApi.api.setFilterModel(null);
    if (Object.getOwnPropertyNames(filters).length == 0) return;
    console.log(filters);
    this.gridApi.api.setFilterModel(filters);
  }

  onSourceItemSelectButtonClick() {
    this.errorInfo = '';
    if (this.selectedCountForSourceGrid == 0) return;
    var node = this.gridOptionsGotoSource.api.getSelectedNodes()[0];
    console.log(node);
    this.gotoSourceData = node.data;
    this.closeChooseItemForSource();
    this.checkSourceAppendButtonState();
  }

  checkSourceAppendButtonState() {
    if (this.movingSourceData == null || this.gotoSourceData == null) {
      this.isAllowSourceAppend = false;
      return;
    }

    let mCaseNr = -1;
    let mInnerNr = -1;
    let mBaraNr = -1;

    if (this.movingCaseValue.value === undefined || this.movingCaseValue.value === '') {
      mCaseNr = 0;
    } else {
      if (!isFinite(this.movingCaseValue.value)) {
        this.isAllowSourceAppend = false;
        return;
      } else {
        mCaseNr = +this.movingCaseValue.value;
      }
    }
    if (this.movingInnerValue.value === undefined || this.movingInnerValue.value === '') {
      mInnerNr = 0;
    } else {
      if (!isFinite(this.movingInnerValue.value)) {
        this.isAllowSourceAppend = false;
        return;
      } else {
        mInnerNr = +this.movingInnerValue.value;
      }
    }
    if (this.movingBaseValue.value === undefined || this.movingBaseValue.value === '') {
      mBaraNr = 0;
    } else {
      if (!isFinite(this.movingBaseValue.value)) {
        this.isAllowSourceAppend = false;
        return;
      } else {
        mBaraNr = +this.movingBaseValue.value;
      }
    }

    // if (mCaseNr < 1 || mBaraNr < 1) {
    //   this.isAllowSourceAppend = false;
    //   return;
    // }
    const move_pcsNr = (mCaseNr * this.movingSourceData.caseamountNr) + (mInnerNr * this.movingSourceData.inneramountNr) + mBaraNr;

    if (move_pcsNr < 1) {
      this.isAllowSourceAppend = false;
      return;
    }
    this.isAllowSourceAppend = validation.integer.test(move_pcsNr + '');
  }

  onSourceAppendButtonClick() {
    this.handleSourceAppend(false)
  }

  async handleSourceAppend(isApply) {
    if (isApply) {
      this.confirmInstockDialogCancel()
    }
    this.errorInfo = '';
    try {
        if (this.movingSourceData == null || this.gotoSourceData == null) {
        this.errorInfo = '登録が可能な移動元/移動先の情報がありません';
        return;
      }

      let mCaseNr = -1;
      let mInnerNr = -1;
      let mBaraNr = -1;

      if (this.movingCaseValue.value === undefined || this.movingCaseValue.value === '') {
        mCaseNr = 0;
      } else {
        if (!isFinite(this.movingCaseValue.value)) {
          this.errorInfo = '移動数(ケース)は、半角数字をセットしてください';
          return;
        } else {
          mCaseNr = +this.movingCaseValue.value;
        }
      }
      if (this.movingInnerValue.value === undefined || this.movingInnerValue.value === '') {
        mInnerNr = 0;
      } else {
        if (!isFinite(this.movingInnerValue.value)) {
          this.errorInfo = '移動数(インナーケース)は、半角数字をセットしてください';
          return;
        } else {
          mInnerNr = +this.movingInnerValue.value;
        }
      }
      if (this.movingBaseValue.value === undefined || this.movingBaseValue.value === '') {
        mBaraNr = 0;
      } else {
        if (!isFinite(this.movingBaseValue.value)) {
          this.errorInfo = '移動数(バラ)は、半角数字をセットしてください';
          return;
        } else {
          mBaraNr = +this.movingBaseValue.value;
        }
      }

      const move_pcsNr = (mCaseNr * this.movingSourceData.caseamountNr) + (mInnerNr * this.movingSourceData.inneramountNr) + mBaraNr;
      if (Number(move_pcsNr) < 1) {
        this.errorInfo = '移動数は、1 以上必要です(ケース数*入り数+バラ数の合計)';
        return;
      }
      //SWMS-1179
      if(Number(this.movingSourceData.pstockNr) < Number(move_pcsNr)){
        this.errorInfo = '移動可能数を超えています。移動可能数（引当可能数）：' + String(this.movingSourceData.pstockNr);
        return;
      }
      
      let itemcaseCd = '999';
      switch (this.gotoSourceData.locablockCd)
      {
         case '1010':
            itemcaseCd = this.movingSourceData.itembaracaseCd;
            break;
         case '1030':
            itemcaseCd = this.movingSourceData.itempycaseCd;
            break;
         case '2010': 
            itemcaseCd = this.movingSourceData.itembybaracaseCd;
            break;
         case '2030': 
           itemcaseCd = this.movingSourceData.itembycaseCd;
           break;
      }
    

      if (this.gotoSourceData.locashelfcaseId != 0 && itemcaseCd != '999' && itemcaseCd != this.gotoSourceData.locacaseCd){
          this.errorInfo = '移動先ロケの格納ケースが、商品マスタの運用設定と異なる格納ケースのため、移動指示を作成できません。';
          return;
      }
        

      if (!isApply) {
        const locaStockInfo = await this.locaStockService
        .get(
          null,
          null,
          null,
          this.gotoSourceData.locaCd,
          null,
          null,
          null
        )
        let usedStock = 0
        if (locaStockInfo.locastocks && locaStockInfo.locastocks.length > 0) {
          usedStock = locaStockInfo.locastocks[0].stockNr || 0
        }

        if (this.movingSourceData.itembaracaseCd != "999" && this.gotoSourceData.locabaracaseCd != "999")  {
              let allCount = 0
              const owner = this.ownerFunctions.filter(o => o.ownerId === this.movingSourceData.ownerId)[0]
              if (owner.arrivrsvlayerexFl === 1) {
                allCount = this.movingSourceData.baraamountNr * this.gotoSourceData.locasplitNr
              } else {
                allCount = this.movingSourceData.baraamountNr
              }

              if (allCount - usedStock < Number(move_pcsNr)) {
                this.showConfirmInstockDialog()
                return
              }
        }

      }
      //this.onTabFocus(2);

      const data = {
        companyId: this.movingSourceData.companyId,
        ownerId: this.movingSourceData.ownerId,
        ownerCd: this.movingSourceData.ownerCd,
        ownerTx: this.movingSourceData.ownerTx,
        logicalwhId: this.movingSourceData.logicalwhId,
        srcItemId: this.movingSourceData.itemId,
        srcItemCd: this.movingSourceData.itemCd,
        srcItemTx: this.movingSourceData.itemTx,
        srcTypestockTx: this.movingSourceData.typestockTx,
        srcTypestockCd: this.movingSourceData.typestockCd,
        srcLotTx: this.movingSourceData.lotTx,
        srcUselimitDt: this.movingSourceData.uselimitDt,
        srcStockDt: this.movingSourceData.stockDt,
        srcLocaId: this.movingSourceData.locaId,
        srcLocaCd: this.movingSourceData.locaCd,
        srcLocaTx: this.movingSourceData.locaTx,
        srcAmountNr: this.movingSourceData.caseamountNr,
        srcInnerAmountNr: this.movingSourceData.inneramountNr,
        destLocaId: this.gotoSourceData.locaId,
        destLocaCd: this.gotoSourceData.locaCd,
        destLocaTx: this.gotoSourceData.locaTx,
        destTypestockTx: this.gotoSourceData.typestockTx,
        moveCaseNr: mCaseNr,
        moveInnerNr: mInnerNr,
        moveBaraNr: mBaraNr,
        movePcsNr: move_pcsNr,
        updprogramCd: this.updprogramCd
      };

      this.movingSourceData = null;
      this.gotoSourceData = null;
      this.movingCaseValue.setValue('');
      this.movingInnerValue.setValue('');
      this.movingBaseValue.setValue('');
      this.movingCaseValue.disable();
      this.movingInnerValue.disable();
      this.movingBaseValue.disable();
      this.showRegisterBlock();
      this.gridOptionsRegistered.api.updateRowData({ add: [data] });
      this.gridHelperForRegister.renderGridCheckboxImage();

    } catch (e) {
      console.log(e);
      console.log(this.commonService.getErrorMessage(e));
      this.errorInfo = this.commonService.getErrorMessage(e);
    }
  }
  /**End Source */

  /** Start Register */
  showRegisterBlock() {
    this.isMovingSourceBlockOpen = false;
    this.isSourceBlockOpen = false;
    this.isRegisterBlockOpen = true;
    this.isEnableRegisterSubmitButton = true;
    this.errorInfo = '';
  }

  onRegisterCancel() {
    this.errorInfo = '';

    this.closeSourceBlock();
    this.isRegisterBlockOpen = false;
    this.isEnableRegisterSubmitButton = false;

    var index = 1;
    var top = this.scrollContent.nativeElement.scrollTop;
    var timerId = setInterval(() => {
      if (index * 100 <= 1000) {
        this.scrollContent.nativeElement.scrollTop = top - top / 10 * index;
        index++;
      }
      else {
        clearInterval(timerId);
      }
    }, 30);

  }
  /** End Register */

  movingPaginatorRowChange() {
    this.gridOptionsMovingSource.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa5010_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  sourcePaginatorRowChange() {
    this.gridOptionsGotoSource.api.paginationSetPageSize(this.sourceRowsPerPage);
    localStorage.setItem('wa5010_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  isMovingSourceItemSelectable(node) {
    const { data } = node
    return (data.stockNr - data.cstockNr) > 0
  }

  movingSourceCellStyle (node) {
    return this.isMovingSourceItemSelectable(node) ? null : { backgroundColor: 'rgba(201, 202, 202, 0.2)' }
  }

  confirmInstockDialogCancel () {
    this.isShowConfirmInstockDialog = false
  }
  showConfirmInstockDialog () {
    this.isShowConfirmInstockDialog = true
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa5Move/wa5011/wa5011.component.ts